// The units this game references for content (decision 0077; pinned exactly in package.json, decision 0076). In the
// browser their tables load from the packages themselves; at build time @rpg/content reads the same packages through
// `content/include.json`. The two lists must match (tools/content.test.ts checks it).
import { STATUS_PRESET_CONTENT } from "@rpg-unit/status-presets";
import { INSTRUMENT_PRESET_CONTENT } from "@rpg-unit/instrument-presets";
import { ENSEMBLE_PRESET_CONTENT } from "@rpg-unit/ensemble-presets";
import { MUSIC_MOOD_PRESET_CONTENT } from "@rpg-unit/music-mood-presets";
import { SFX_KIT_CONTENT } from "@rpg-unit/sfx-kits";
import { CAMERA_PROFILE_CONTENT } from "@rpg-unit/camera-profile-presets";
import { FOLLOW_CAMERA_CONTENT } from "@rpg-unit/follow-camera";
import { IMPACT_CUE_CONTENT } from "@rpg-unit/impact-cue-presets";
import { LOOK_PRESET_CONTENT } from "@rpg-unit/look-presets";
import { STANDARD_SETTINGS_CONTENT } from "@rpg-unit/standard-settings";
import { ENEMY_ARCHETYPE_CONTENT } from "@rpg-unit/enemy-archetypes";
import { SHOP_PRESET_CONTENT } from "@rpg-unit/shop-presets";
import type { JsonSchema, TableFile } from "@rpg/content";

/** A referenced unit's content: its package, version, tables and their schemas. */
export interface UnitContent {
  package: string;
  version: string;
  tables: readonly TableFile[];
  schemas: Readonly<Record<string, JsonSchema>>;
}

/** Every unit whose tables join the game's, in content/include.json's order. */
export const UNIT_CONTENT: readonly UnitContent[] = [
  STATUS_PRESET_CONTENT as unknown as UnitContent,
  INSTRUMENT_PRESET_CONTENT as unknown as UnitContent,
  ENSEMBLE_PRESET_CONTENT as unknown as UnitContent,
  MUSIC_MOOD_PRESET_CONTENT as unknown as UnitContent,
  SFX_KIT_CONTENT as unknown as UnitContent,
  CAMERA_PROFILE_CONTENT as unknown as UnitContent,
  FOLLOW_CAMERA_CONTENT as unknown as UnitContent,
  IMPACT_CUE_CONTENT as unknown as UnitContent,
  LOOK_PRESET_CONTENT as unknown as UnitContent,
  STANDARD_SETTINGS_CONTENT as unknown as UnitContent,
  ENEMY_ARCHETYPE_CONTENT as unknown as UnitContent,
  SHOP_PRESET_CONTENT as unknown as UnitContent,
];
